var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuessCompound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.3,
    height: 21.182,
    viewBox: "0 0 23.3 21.182",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26993",
    "data-name": "Trac\\xE9 26993",
    d: "M22.113,18.811a3.2,3.2,0,0,0-1.831.593l-2.594-1.535a4.042,4.042,0,0,0,.191-1.175A4.234,4.234,0,0,0,14.7,12.608V10.152a3.174,3.174,0,1,0-2.117,0v2.456A4.234,4.234,0,0,0,9.41,16.694,4.042,4.042,0,0,0,9.6,17.869L7.007,19.4a3.168,3.168,0,1,0,1.344,2.583,3.28,3.28,0,0,0-.127-.847l2.435-1.45a4.236,4.236,0,0,0,5.97,0l2.435,1.45a3.174,3.174,0,1,0,3.049-2.329ZM5.176,23.045a1.059,1.059,0,1,1,1.059-1.059A1.062,1.062,0,0,1,5.176,23.045ZM13.644,6.108a1.059,1.059,0,1,1-1.059,1.059A1.062,1.062,0,0,1,13.644,6.108Zm0,12.7a2.117,2.117,0,1,1,2.117-2.117A2.117,2.117,0,0,1,13.644,18.811Zm8.469,4.234a1.059,1.059,0,1,1,1.059-1.059A1.062,1.062,0,0,1,22.113,23.045Z",
    transform: "translate(-2 -3.98)",
    fill: "#6f7070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuessCompound);
export default __webpack_public_path__ + "static/media/quess_compound.90e0b2b6a2fafb4ccae181c2ecea975b.svg";
export { ForwardRef as ReactComponent };